import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export interface UserInterface {
  displayName: String;
  gender: String;
  image: any;
  isAdmin: boolean;
  verifiedAccount: boolean;
}

export interface Wallet {
  availablePoints: number;
  hasWallet: boolean;
  purchasedDovepoints: number;
}

export interface AuthContextProps {
  refreshDovePoints: () => void;
  authToken: string | null;
  setToken: (data: string) => void | null;
  logout: () => void;
  user: UserInterface | null;
  isLoading: boolean;
  wallet: Wallet | null;
  setUser: Dispatch<SetStateAction<null | UserInterface>>;
  setWallet: Dispatch<SetStateAction<null | Wallet>>;
}

// TODO: add empty context object
export const AuthContext = createContext<AuthContextProps>(undefined!);

export function useAuth() {
  return useContext(AuthContext);
}
